export const ADMIN_USER_ROW_SM = 80;

export const ADMIN_USER_ROW_LG = 80;
